import { render, staticRenderFns } from "./CompanyIntroduce.vue?vue&type=template&id=470d1124&scoped=true"
import script from "./CompanyIntroduce.vue?vue&type=script&lang=js"
export * from "./CompanyIntroduce.vue?vue&type=script&lang=js"
import style0 from "./CompanyIntroduce.vue?vue&type=style&index=0&id=470d1124&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d1124",
  null
  
)

export default component.exports